module.exports = __webpack_public_path__ + "static/media/PANORA.6defdafb.svg";